module.exports = __webpack_public_path__ + "img/star2.f990c642.png";